import React from 'react'

import './style.scss'
import { SkeletonConfig } from './enums'
import { SkeletonProps } from './types'

export const Skeleton: React.FC<SkeletonProps> = ({ width, height = 100, rounded = SkeletonConfig.Rounded.Md, className, children }: SkeletonProps) => {
  return (
    <div className={`ds-skeleton ${className || ''}`}>
      <div className={`ptz-rounded-${rounded}`} style={width ? { width: `${width}px`, height: `${height}px` } : { height: `${height}px` }}>
        <span>{children}</span>
      </div>
    </div>
  )
}
